import { PathName } from '../../../utils/UrlUtils';
import postMessage from '../../../post-message/PostMessageUtils';
const secureMessagingLaunchParameter = 'secureMessaging';
const proactiveLaunchUrls = [
    { value: process.env.REACT_APP_essSecureMessagingProactiveLaunchUrl, launchParameter: secureMessagingLaunchParameter },
    { value: process.env.REACT_APP_mySyfSecureMessagingProactiveLaunchUrl, launchParameter: secureMessagingLaunchParameter },
    { value: process.env.REACT_APP_mySyfSecureMessagingContactUsProactiveLaunchUrl, launchParameter: secureMessagingLaunchParameter },
];
function sendAutoLaunchMessage(almeState) {
    /**
     * Do not send autolaunch messsage when IVA is open or conversation has occurred
     */
    if (almeState.isOpen || almeState.history.length >= 1) {
        return;
    }
    const launchUrl = proactiveLaunchUrls.find((url) => url.value && PathName.endsWith(url.value));
    if (launchUrl) {
        setTimeout(() => postMessage({
            type: "LaunchIva",
            launchPointName: "AutoLaunch",
            launchParameter: launchUrl.launchParameter,
            source: 'nit',
        }), 1000);
    }
}
export default sendAutoLaunchMessage;
